import React from 'react';
import restauranteroLogo from 'images/restaurantero-logo-white.png';

export default function HomePage() {
  return (
    <div style={{
      minHeight: '100vh',
      background: 'linear-gradient(150deg, #111827 0%, #1e293b 100%)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <img
        src={restauranteroLogo}
        alt='Restaurantero'
        style={{ height: '36px' }}
      />
    </div>
  );
}
